export const validaEmail = ((email) => {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[\p{L}\p{N}-]+(\.[\p{L}\p{N}-]+)*$/u;
    if (email.match(validRegex)) {
        return true;
    } else {
        return false;
    }
})

export const abreviaString = (texto, limite, limitador = '...') => {
    if(texto){
        if (texto.length > limite) {
            return texto.substr(0, limite - limitador.length) + limitador;
        }
    }
    return texto;
};

export const saudacao = ( () => {
    let resp = ''
    let hr = new Date().getHours()
    if (hr >= 12 && hr < 18) {
        resp = "Boa tarde";
    } else if (hr >= 0 && hr < 12) {
        resp = "Bom dia";
    } else {
        resp = "Boa noite";
    }
    return  resp;
})

export const removeHtml = ((html) => {
    if(html){
        return html.replace(/<[^>]+>/g, '')
    }else{
        return ''
    }
})

export const converterParaMaiusculas = (input) => {
    if (typeof input !== 'string') {
        return input;
    }
    return input.split('').map(char => {
        if (char >= 'a' && char <= 'z') {
            return String.fromCharCode(char.charCodeAt(0) - 32);
        }
        return char;
    }).join('');
};

export const ocultaCaracteres = (input) => {
    if (typeof input !== 'string') {
        return input;
    }
    if (!input) {
        return '';
    } 
    if (input.length  <= 4) {
        return input;
    }
    const visibleChars = 4;
    return input.substring(0, visibleChars) + '*'.repeat(input.length - visibleChars);
}

export const geraSlug = (texto) => {
    return texto
    .toLowerCase()
    .normalize('NFD') 
    .replace(/[\u0300-\u036f]/g, '') 
    .replace(/ /g, '_') 
    .replace(/[^a-z0-9_]/g, ''); 
}

// Validação estrita de e-mail (GCK-20937): além do formato aceito por
// `validaEmail`, exige domínio com pelo menos um ponto e TLD com 2+ letras
// (usuario@dominio.com.br) e bloqueia espaços. Usada onde o e-mail alimenta
// documento fiscal e não pode falhar na emissão.
export const validaEmailEstrito = (email) => {
    if (!email) {
        return true
    }
    const texto = String(email)
    if (/\s/.test(texto)) {
        return false
    }
    const formato = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
    return formato.test(texto)
}

// Valida nome / razão social (GCK-20937): mínimo de 3 caracteres úteis
// (letras e números, ignorando pontuação e espaços) e pelo menos uma letra —
// bloqueia "123", "1.234", "@@@" e afins.
export const validaNome = (nome) => {
    if (!nome) {
        return true
    }
    const texto = String(nome).trim()
    if (texto === '') {
        return true
    }
    const uteis = texto.replace(/[^\p{L}\p{N}]/gu, '')
    if (uteis.length < 3) {
        return false
    }
    return /\p{L}/u.test(texto)
}
